// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1d_oo","col":"styles_col__32H7N","actions":"styles_actions__dzuuR","conflict":"styles_conflict__3PYtI"};